var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RecentDocumentsItemContainer',{class:_vm.$style.container},[_c('div',{class:_vm.$style.desc},[_vm._v(" "+_vm._s(_vm.text || 'You don’t have any project.')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }